<template>
  <div>
    <div class="wrap-float">
      <h1 class="subtitle align-left">Le saviez-vous ?</h1>
      <a class="button is-small is-white align-right" @click="changetip('up')">
        <awesome-icon icon="chevron-right" />
      </a>
      <a class="button is-small is-white align-right" @click="changetip('down')">
        <awesome-icon icon="chevron-left" />
      </a>
    </div>
    <div>{{ tip.message }}</div>
  </div>
</template>

<script>
import { tipsConso, tipsBenchmark } from "../helpers";

export default {
  props: ['tipsType'],
  data() {
    return {
      tipsArray: [],
      tip: { index: 0, message: "" }
    };
  },
  created() {
    this.tipsArray = this.tipsType == '/comparison' ? tipsBenchmark : tipsConso;
    this.tip = { index: 0, message: this.tipsArray[0].message }
  },
  methods: {
    changetip(direction) {
      let index = 0;
      if (direction == 'up') {
        index = this.tip.index == this.tipsArray.length - 1 ? 0 : this.tip.index + 1;
      } else {
        index = this.tip.index == 0 ? this.tipsArray.length - 1 : this.tip.index - 1;
      }
      this.tip = { index, message: this.tipsArray[index].message };
    }
  }
};
</script>

<style lang="scss" scoped>
.align-left {
  float: left;
}

.align-right {
  float: right;
}

.wrap-float {
  overflow: auto;

  & .subtitle {
    margin-bottom: .5rem;
  }
}
</style>